import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { ManageContractorProfilePage } from "./pages/manage-contractor-profile";
import { PublicContractorProfilePage } from "./pages/public-contractor-profile";

export const contractorProfileRoutes: RouteObject[] = [
	{
		path: "/contractor-profile",
		element: (
			<ProtectedRoute requireUserType="contractor">
				<ManageContractorProfilePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/contractor-profile/:slug",
		element: <PublicContractorProfilePage />,
	},
];
